import { api } from '@api'
import { Routes, RoutesFilters, RoutesFiltersResponse } from '@types'

const base = '/sap-tpt'

interface GetRoutesResponse {
  routes: Routes
}
type Params = {
  filters?: RoutesFilters
}
const getRoutes = async (params: Params) => {
  const { filters } = params
  const response = await api.get<GetRoutesResponse>(base, {
    params: filters,
  })

  return response.data.routes
}
const getAllRoutes = async (params: Params) => {
  const { filters } = params
  const response = await api.get<GetRoutesResponse>(base, {
    params: {
      ...filters,
      page: 1,
      limit: 2000,
    },
  })

  return response.data.routes
}

const getRoutesFilters = async () => {
  const response = await api.get<RoutesFiltersResponse>(base + '/filters')

  return response.data
}

export const routesApi = { getRoutes, getAllRoutes, getRoutesFilters }
